import "./index.css";
// src/ArtifactDisclaimer/ArtifactDisclaimer.tsx
import Icon from "@cloudscape-design/components/icon";
import Link2 from "@cloudscape-design/components/link";
import * as React from "react";
import { AppTrans as AppTrans3 } from "@amzn/awsmp-max-translations";

// src/DisclaimerModal/AwsTermsDisclaimerModal.tsx
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import TextContent from "@cloudscape-design/components/text-content";
import Link from "@cloudscape-design/components/link";
import { useAppTranslation, AppTrans } from "@amzn/awsmp-max-translations";
import { jsx, jsxs } from "react/jsx-runtime";

// src/DisclaimerModal/AiContentDisclaimerModal.tsx
import Modal2 from "@cloudscape-design/components/modal";
import Box2 from "@cloudscape-design/components/box";
import Button2 from "@cloudscape-design/components/button";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import TextContent2 from "@cloudscape-design/components/text-content";
import { useAppTranslation as useAppTranslation2, AppTrans as AppTrans2 } from "@amzn/awsmp-max-translations";
import { jsx as jsx2 } from "react/jsx-runtime";
var AiContentDisclaimerModal = ({ visible, onDismiss }) => {
  const { t } = useAppTranslation2();
  return /* @__PURE__ */ jsx2(
    Modal2,
    {
      size: "medium",
      onDismiss,
      visible,
      footer: /* @__PURE__ */ jsx2(Box2, { float: "right", children: /* @__PURE__ */ jsx2(Button2, { variant: "primary", onClick: onDismiss, children: t("close") }) }),
      "data-testid": "ai-content-disclaimer-modal",
      children: /* @__PURE__ */ jsx2(SpaceBetween2, { direction: "vertical", size: "m", children: /* @__PURE__ */ jsx2(TextContent2, { children: /* @__PURE__ */ jsx2(AppTrans2, { i18nKey: "artifactAiDisclaimerModalContent" }) }) })
    }
  );
};

// src/ArtifactDisclaimer/ArtifactDisclaimer.module.scss
var ArtifactDisclaimer_module_default = {
  disclaimerContainer: "ArtifactDisclaimer_module_disclaimerContainer"
};

// src/ArtifactDisclaimer/ArtifactDisclaimer.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ArtifactDisclaimer = ({ className }) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx3("div", { className: className || ArtifactDisclaimer_module_default.disclaimerContainer, "data-testid": "artifact-disclaimer", children: /* @__PURE__ */ jsxs2(AppTrans3, { i18nKey: "artifactDisclaimer", children: [
      /* @__PURE__ */ jsx3(Icon, { name: "gen-ai", size: "small" }),
      /* @__PURE__ */ jsx3(Link2, { variant: "primary", onFollow: () => setModalVisible(true), "data-testid": "disclaimer-learn-more-link" })
    ] }) }),
    /* @__PURE__ */ jsx3(AiContentDisclaimerModal, { visible: modalVisible, onDismiss: () => setModalVisible(false) })
  ] });
};
export {
  ArtifactDisclaimer
};
//# sourceMappingURL=index.js.map
